import * as React from 'react';
import * as Classes from '../common/classes';

type Props = {};
export const Deleted: React.FC<Props> = ({}) => {
  return (
    <div className={Classes.DELETED}>
      <hr />
    </div>
  );
};
